import Navbar from "@/components/site/Navbar";
import HeroMap from "@/components/site/HeroMap";
import ScheduleSection from "@/components/site/ScheduleSection";
import PromoSection from "@/components/site/PromoSection";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-sc-blue" data-testid="home-page">
      <Navbar />
      <HeroMap />
      <ScheduleSection />
      <PromoSection />
      <BookingForm />
      <Footer />
    </div>
  );
}
